import { render, staticRenderFns } from "./VersionsDocument.vue?vue&type=template&id=4d90b85b&scoped=true&"
import script from "./VersionsDocument.vue?vue&type=script&lang=js&"
export * from "./VersionsDocument.vue?vue&type=script&lang=js&"
import style0 from "./VersionsDocument.vue?vue&type=style&index=0&id=4d90b85b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90b85b",
  null
  
)

export default component.exports